const fontSizes = [0, 12, 14, 16, 20, 24, 32, 36, 48, 90].map(
  s => `${s / 16}rem`
);

export default fontSizes;
